import * as React from 'react';
import { Menu_menu_categories as Category, Menu_menu_categories_items as MenuItem } from './__generated__/Menu';
import { MenuTile } from './MenuTile';

export interface MenuSectionProps {
  category: Category;
  onOrderChange(ids: string[]);
  onClickNewItem(categoryId);
  onDeleteItem(item: MenuItem);
  onToggleEnabled(item: MenuItem);
  onToggleFeatured(item: MenuItem);
  onSelectItem(item: MenuItem);
  copyMenuItem(item: MenuItem);
}

export interface MenuSectionState {
  menuOpen: MenuItem | false;
  menuItems: MenuItem[];
}

export class MenuSection extends React.Component<MenuSectionProps, MenuSectionState> {
  constructor(props: MenuSectionProps) {
    super(props);

    this.state = { menuOpen: false, menuItems: props.category.items };
  }

  moveItem = (dragIndex, hoverIndex) => {
    const { menuItems } = this.state;
    const dragCard = menuItems[dragIndex];

    const itemsCopy = [...this.state.menuItems];
    itemsCopy.splice(dragIndex, 1);
    itemsCopy.splice(hoverIndex, 0, dragCard);

    this.setState(
      {
        menuItems: itemsCopy,
      },
      () => {
        const ids = this.state.menuItems.map((menuItem) => menuItem.item.id);
        this.props.onOrderChange(ids);
      }
    );
  };

  onClickNewItem = () => {
    this.props.onClickNewItem(this.props.category.id);
  };

  openMenu = (item: MenuItem) => {
    this.setState({ menuOpen: item });
  };

  hideMenu = () => this.setState({ menuOpen: false });

  renderItem = (menuItem: MenuItem, index) => {
    return (
      <MenuTile
        key={menuItem.item.id}
        onDeleteItem={this.props.onDeleteItem}
        onToggleEnabled={this.props.onToggleEnabled}
        onToggleFeatured={this.props.onToggleFeatured}
        onSelectItem={this.props.onSelectItem}
        index={index}
        menuItem={menuItem}
        openMenu={this.openMenu}
        hideMenu={this.hideMenu}
        menuOpen={this.state.menuOpen === menuItem}
        moveCard={this.moveItem}
        copyMenuItem={this.props.copyMenuItem}
      />
    );
  };

  renderAddButton = () => {
    if (this.props.category.salesCategory) {
      return (
        <a className='dashed-add-button' role='button' onClick={this.onClickNewItem}>
          <span>+</span>
          Add Item
        </a>
      );
    }
  };

  render() {
    return (
      <div key={this.props.category.id} className='lg-vertical-md-margin menu-tile-container'>
        {this.renderAddButton()}
        {this.state.menuItems.map(this.renderItem)}
      </div>
    );
  }
}
